import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import { userService, GetUsersParams, CreateUserRequest, UpdateUserRequest } from "./user.service";
import { userKeys } from "./user.keys";

export const useUsers = (params: GetUsersParams = {}) => {
  return useQuery({
    queryKey: userKeys.list(params),
    queryFn: () => userService.getUsers(params),
  });
};

export const useCreateUser = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (userData: CreateUserRequest) => userService.createUser(userData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: userKeys.all });
      message.success("User created successfully!");
    },
    onError: (error: any) => {
      message.error(error.response?.data?.message || "Failed to create user!");
    },
  });
};

export const useUpdateUser = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, userData }: { id: string; userData: UpdateUserRequest }) =>
      userService.updateUser(id, userData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: userKeys.all });
      message.success("User updated successfully!");
    },
    onError: (error: any) => {
      message.error(error.response?.data?.message || "Failed to update user!");
    },
  });
};

export const useDeleteUser = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (id: string) => userService.deleteUser(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: userKeys.all });
      message.success("User deleted successfully!");
    },
    onError: (error: any) => {
      message.error(error.response?.data?.message || "Failed to delete user!");
    },
  });
}; 